import { OrganisationState } from '../types';

export const initialState: OrganisationState = {
  loading: false,
  organisations: undefined,
  mappings: undefined,
  mappedOrganisations: undefined,
  showActions: false,
  showConnections: false,
  mappedReturns: undefined,
  selectedEntityAccounts: undefined,
  organisationViesContacts: undefined,
  uploadTransactionsTemp: undefined,
  uploadExcelTransactionsValidationData: undefined,
  uploadExcelTransactionsStatus: null,
  uploadedFileTransactionsPage: undefined,
  allExcelTransactionsPage: undefined,
  allExcelTransactionsLoading: false,
  isPostingToProvider: false,
  lastUploadedReceiptsBatchId: null,
  lastReceiptUploadStatus: undefined,
  bulkUpdateExcelTransactionsSuccessCount: 0,
  excelDrawerTransactionsBatchSaving: false,
  drawerTransactionIdMap: {},
  pendingExcelTransactionRollback: null,
  uploadInitFailed: false,
};
